$(document).on('turbo:load', function() {
  $(document).on('change', '.advisors-road-component select[name=timeline]', function() {
    const timeline = $(this).val();
    const component = $(this).closest('.advisors-road-component');
    const hsCompanyId = component.attr('hs_company_id');
    $.get(`/components/advisors/road?hs_company_id=${hsCompanyId}&timeline=${timeline}`).done(function(html) {
      component.replaceWith(html);
    }).always(function() {
      // Update Road To 84 Funnel component on the page with the same timeline
      const roadTo84FunnelDropdown = $('.advisors-road-funnel-component select[name=timeline]').first();
      if (roadTo84FunnelDropdown.val() !== timeline) roadTo84FunnelDropdown.val(timeline).trigger('change');
    }).fail(function(e) {
      console.error(e);
    });
  });
});